import { render } from "./warningDetails.vue?vue&type=template&id=5dd097cc&scoped=true"
import script from "./warningDetails.vue?vue&type=script&lang=js"
export * from "./warningDetails.vue?vue&type=script&lang=js"

import "./warningDetails.vue?vue&type=style&index=0&id=5dd097cc&lang=scss&scoped=true"

import exportComponent from "D:\\projects\\gitlab\\DemoLab\\DemoLab-data\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd097cc"]])

export default __exports__